/* global modForm */
/**
 * Wire all form elements based on selectors
 */
export function initFormElements() {
	modForm.opts.formElemsSelectors = { ...modForm.opts.formElemsSelectorsDefaults, ...modForm.opts.formElemsSelectors };
	Object.keys(modForm.opts.formElemsSelectors).forEach((key) => {
		if (!modForm.opts[key]) {
			modForm.opts[key] = modForm.opts.form.querySelectorAll(modForm.opts.formElemsSelectors[key]);
		}
	});
	if (modForm.opts.useShowStepConditionally) {
		modForm.opts.conditionalShowStepInputs = Array.from(
			modForm.opts.form.querySelectorAll('input[type="radio"][data-show-step], input[type="checkbox"][data-show-step]')
		);
	}
	// Storing original tcpa after getting the tcpaelement from its selector
	modForm.opts.originalTcpa = modForm.opts.tcpaCopy && modForm.opts.tcpaCopy.length ? modForm.opts.tcpaCopy[0].innerHTML : '';
}
